// extracted by mini-css-extract-plugin
export var boldText = "_84-4";
export var checkboxContainer = "_84-6";
export var closeIcon = "_84-i";
export var container = "_84-0";
export var drawer = "_84-8";
export var drawerContent = "_84-9";
export var extraSmallText = "_84-5";
export var fulfillmentGroupTable = "_84-e";
export var largeText = "_84-3";
export var loadingSpinnerContainer = "_84-j";
export var mediumText = "_84-2";
export var narrow = "_84-f";
export var notificationLink = "_84-l";
export var packageCheckIconContainer = "_84-7";
export var slideoutHeaderActions = "_84-g";
export var slideoutHeaderActionsShifted = "_84-h";
export var slideoutHeaderContainer = "_84-a";
export var slideoutModal = "_84-c";
export var stickyHeaderWrapper = "_84-b";
export var table = "_84-k";
export var tableContainer = "_84-d";
export var tertiaryText = "_84-1";